export default __webpack_public_path__ + "assets/bold.b7acf983.svg";